// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__XNv_e","calendarButtons":"ClockData_calendarButtons__2TBm7"};